import { TableCell } from '@mui/material';
import type { TableData } from 'app/common/components/table/types';
import styled from 'styled-components';
import { ContentItemCollab } from '../content-item-collab';

const CollabCellContainer = styled(TableCell)`
  vertical-align: middle;
`;

export type CollabCellProps = {
  readonly row: TableData;
  readonly idFieldName?: string;
};

export function CollabCell(props: CollabCellProps) {
  const { row, idFieldName } = props;
  const id = idFieldName ? row[idFieldName] : row.id;
  return (
    <CollabCellContainer>
      <ContentItemCollab contentId={id} viewAvatarCount={1} />
    </CollabCellContainer>
  );
}

export default CollabCell;
